<app-header (toggleEvent)="toggleNav($event)"></app-header>
<div class="container-fluid sectionContainer p-3">
  <mat-sidenav-container class="example-container" [hasBackdrop]="false" autosize>
    <mat-sidenav
      #sidenav
      class="example-sidenav"
      mode="over"
      [(opened)]="sidenavToggle"
    >
      <app-mail-box *ngIf="sidenavToggle" (closeMailEvent)="toggleNav($event)"></app-mail-box>
    </mat-sidenav>
    <mat-sidenav-content class="sidenav_content_flex">
      <div class="row row-flex">
        <div class="col-md-12">
          <span class="MSB24">Doctor's List</span>
        </div>
      </div>
      <div class="row row-flex">
        <div class="col-md-4">
          <div class="doctor_field">
            <mat-form-field
              class="example-full-width greenBorder MSB16"
              floatLabel="never"
            >
              <input
                matInput
                (keyup)="applyFilter($event)"
                [formControl]="doctorSearch"
                placeholder="Search"
                #search
              />
              <span matSuffix>
                <mat-icon class="align-bottom">search</mat-icon>
              </span>
            </mat-form-field>
          </div>
        </div>
        <div class="col-md-8">
          <!--<button
            mat-raised-button
            color="primary"
            class="save_secondary mb-4"
            style="float: right;"
          >
            <mat-icon>get_app</mat-icon>
            Download List
          </button>-->
          <button
            class="save_secondary"
            mat-raised-button
            (click)="openDialog()"
            color="primary"
            aria-label="Example icon button with a add icon"
          >
            <mat-icon>add</mat-icon>
            Add
          </button>
        </div>
      </div>
      <div class="row row-flex mt-2">
        <div class="col-md-12">
          <div class="table_conatct">
            <table
              *ngIf="dataSource.filteredData.length != 0"
              mat-table
              [dataSource]="dataSource"
              class="mat-elevation-z8 MM18"
            >
              <ng-container matColumnDef="doctorName">
                <th mat-header-cell *matHeaderCellDef>Doctor's Name</th>
                <td mat-cell class="cell_space_util" *matCellDef="let element">
                  {{ element.doctorName }}
                </td>
              </ng-container>

              <ng-container matColumnDef="registeredNo">
                <th mat-header-cell *matHeaderCellDef>Registered No</th>
                <td mat-cell class="cell_space_util" *matCellDef="let element">
                  {{ element.registrationNumber }}
                </td>
              </ng-container>

              <ng-container matColumnDef="email">
                <th mat-header-cell *matHeaderCellDef>Email ID</th>
                <td mat-cell class="cell_space_util" *matCellDef="let element">
                  {{ element.email }}
                </td>
              </ng-container>

              <ng-container matColumnDef="contactNo">
                <th mat-header-cell *matHeaderCellDef>Contact Number</th>
                <td mat-cell class="cell_space_util" *matCellDef="let element">
                  {{ element.contactNo }}
                </td>
              </ng-container>

              <ng-container matColumnDef="speciality">
                <th mat-header-cell *matHeaderCellDef>Speciality</th>
                <td mat-cell class="cell_space_util" *matCellDef="let element">
                  {{ element.speciality }}
                </td>
              </ng-container>

              <ng-container matColumnDef="education">
                <th mat-header-cell *matHeaderCellDef>Education</th>
                <td mat-cell class="cell_space_util" *matCellDef="let element">
                  {{ element.highestEducation }}
                </td>
              </ng-container>

              <ng-container matColumnDef="visitDetails">
                <th mat-header-cell *matHeaderCellDef>Visit Details</th>
                <td mat-cell class="cell_space_util" *matCellDef="let element">
                  <button
                    mat-button
                    color="primary"
                    class="MM14"
                    (click)="openViewDialog(element)"
                    aria-label="Example icon button with a edit icon"
                  >
                    View Details
                  </button>
                </td>
              </ng-container>

              <ng-container matColumnDef="actions">
                <th mat-header-cell *matHeaderCellDef class="text-center">
                  Actions
                </th>
                <td
                  mat-cell
                  class="cell_space_util text-center"
                  *matCellDef="let element"
                >
                  <button
                    mat-mini-fab
                    (click)="openEditDialog(element)"
                    class="table_edit_btn"
                    aria-label="Example icon button with a edit icon"
                  >
                    <mat-icon>edit</mat-icon>
                  </button>
                  <button
                    mat-mini-fab
                    class="table_delete_btn"
                    (click)="deleteDoctorEntry(element.doctorId)"
                    aria-label="Example icon button with a delete icon"
                  >
                    <mat-icon>delete</mat-icon>
                  </button>
                </td>
              </ng-container>

              <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
              <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
            </table>
            <mat-paginator
              class="mat-elevation-z8 full-width-field"
              [length]="resultsLength"
              [pageSize]="15"
              showFirstLastButtons
            ></mat-paginator>
          </div>
        </div>
      </div>
      <div
        class="row m-4"
        style="background-color: #8aa9ff15; min-height: 415px"
        *ngIf="dataSource.filteredData.length === 0"
      >
        <div class="col-4 offset-md-4 mt-5 text-center">
          <img src="assets/icons/Shared/Group 595.png" /> <br /><br />
          <span class="MM24">There are no Doctor details available</span>
          <p class="MM18">Please try adding a new Doctor</p>
        </div>
      </div>
      <div class="row row-flex">
        <div class="col-md-12">
          <button
            mat-raised-button
            color="warn"
            (click)="lastRoute()"
            class="save_changes"
            style="margin-top: 0.625rem"
          >
            Go Back
          </button>
        </div>
      </div>
    </mat-sidenav-content>
  </mat-sidenav-container>
</div>
